import { createReducer } from "reduxsauce";
import ReducerRegister from "../../../../ReducerRegister";
import { ActionTypes } from "../../../../actionTypes/screens/admin/agent/subagent/EditActionTypes";
import EditService from "../../../../../services/screens/admin/agent/subagent/EditService"
import ManageUserService from "../../../../../services/screens/admin/user/ManageUserService";
import AsyncActionReducers from "../../../../AsyncActionReducers";
import { ActionTypes as LoginActionTypes } from "../../../../actionTypes/screens/account/LoginActionTypes";
import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.agent.subagent.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (id, userrole) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id, userrole });

            EditService.loadScreenView(
                id, userrole,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    getPartnerByEmailAsync: (email) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.GET_PARTNER_BY_EMAIL_ASYNC, email });

            EditService.getPartnerByEmail(
                email,
                response => {
                    dispatch(Actions.getPartnerByEmailSuccess(response, email));
                },
                error => {
                    dispatch(Actions.getPartnerByEmailFailure(error));
                }
            );
        };
    },

    getPartnerByEmailSuccess: (data, email) => ({
        type: ActionTypes.GET_PARTNER_BY_EMAIL_SUCCESS,
        parentType: ActionTypes.GET_PARTNER_BY_EMAIL_ASYNC,
        postReducer: getPartnerByEmailSuccessPostReducer,
        data, email
    }),

    getPartnerByEmailFailure: error => ({
        type: ActionTypes.GE_PARTNER_BY_EMAIL_FAILURE,
        parentType: ActionTypes.GET_PARTNER_BY_EMAIL_ASYNC,
        error
    }),

    saveAgentAsync: (vo) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.SAVE_AGENT_ASYNC, vo });

            EditService.addAgent(vo,
                response => {
                    dispatch(Actions.saveAgentSuccess(response));
                },
                error => {
                    dispatch(Actions.saveAgentFailure(error));
                }
            );
        };
    },

    saveAgentSuccess: data => ({
        type: ActionTypes.SAVE_AGENT_SUCCESS,
        parentType: ActionTypes.SAVE_AGENT_ASYNC,
        postReducer: saveAgentSuccessPostReducer,
        data
    }),

    saveAgentFailure: error => ({
        type: ActionTypes.SAVE_AGENT_FAILURE,
        parentType: ActionTypes.SAVE_AGENT_ASYNC,
        error
    }),

    updateAgentAsync: (vo) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.UPDATE_AGENT_ASYNC, vo });

            EditService.updateAgent(vo,
                response => {
                    dispatch(Actions.updateAgentSuccess(response));
                },
                error => {
                    dispatch(Actions.updateAgentFailure(error));
                }
            );
        };
    },

    updateAgentSuccess: data => ({
        type: ActionTypes.UPDATE_AGENT_SUCCESS,
        parentType: ActionTypes.UPDATE_AGENT_ASYNC,
        data
    }),

    updateAgentFailure: error => ({
        type: ActionTypes.UPDATE_AGENT_FAILURE,
        parentType: ActionTypes.UPDATE_AGENT_ASYNC,
        error
    }),

    getAllCountryCodeAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC });

            EditService.getAllCountryCode(
                response => {
                    dispatch(Actions.getAllCountryCodeSuccess(response));
                },
                error => {
                    dispatch(Actions.getAllCountryCodeFailure(error));
                }
            );
        };
    },

    getAllCountryCodeSuccess: data => ({
        type: ActionTypes.GET_ALL_COUNTRY_CODE_SUCCESS,
        parentType: ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC,
        postReducer: getAllCountryCodeSuccessPostReducer,
        data
    }),

    getAllCountryCodeFailure: error => ({
        type: ActionTypes.GET_ALL_COUNTRY_CODE_FAILURE,
        parentType: ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC,
        error
    }),

    updateValues: (newData) => ({
        type: ActionTypes.UPDATE_VALUES,
        newData
    }),

    loginOtherTeacherAsync: (id, isLoginFromAdminStatic, superAdminBackupData) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOGIN_OTHER_TEACHER_ASYNC, id, isLoginFromAdminStatic, superAdminBackupData });

            ManageUserService.loginTeacherForAgent(id,
                response => {
                    dispatch({
                        type: LoginActionTypes.LOGIN_SUCCESS,
                        parentType: LoginActionTypes.LOGIN_ASYNC,
                        data: { ...response, isLoginFromAdminStatic, superAdminBackupData, isLoginFromAgent: true },
                    });
                    dispatch(Actions.loginOtherTeacherSuccess(response));
                },
                error => {
                    dispatch(Actions.loginOtherTeacherFailure(error));
                }
            );
        };
    },

    loginOtherTeacherSuccess: data => ({
        type: ActionTypes.LOGIN_OTHER_TEACHER_SUCCESS,
        parentType: ActionTypes.LOGIN_OTHER_TEACHER_ASYNC,
        data
    }),

    loginOtherTeacherFailure: error => ({
        type: ActionTypes.LOGIN_OTHER_TEACHER_FAILURE,
        parentType: ActionTypes.LOGIN_OTHER_TEACHER_ASYNC,
        error
    }),
};

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
    agentInfo: null,
    referralCodeAsAgent: null,
    countryCodeList: null,
    sendPwd: null,
    referralCodeAsTeacher: null,
};

/* ------------- Reducers ------------- */
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, agentInfo: {...data.agentInfo, firstName:data.agentInfo.name}};
};

const getPartnerByEmailSuccessPostReducer = (state, { data, email }) => {
    var newVO = {
        ...state.agentInfo,
        isTeacher: data.partner.isTeacher,
        organization: data.partner.organization,
        referrerCode: data.partner.referrerCode,
        referrerName: data.partner.referrerName,
    };
    return { ...state, agentInfo: newVO};
};

const updateValuesReducer = (state, { newData }) => {
    return { ...state, agentInfo: newData };
};

const saveAgentSuccessPostReducer = (state, { data }) => {
    return { ...state, referralCodeAsAgent: data.referralCodeAsAgent, sendPwd: data.sendPwd, referralCodeAsTeacher: data.referralCodeAsTeacher };
};

const getAllCountryCodeSuccessPostReducer = (state, { data }) => {
    if (!state.agentInfo) {
        return { ...state, agentInfo: {}, countryCodeList: data };
    }
    return { ...state, countryCodeList: data };
};

/* ------------- Hookup Reducers To Types ------------- */

const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_AGENT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_AGENT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_AGENT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_AGENT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPDATE_AGENT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPDATE_AGENT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.GET_ALL_COUNTRY_CODE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.GET_ALL_COUNTRY_CODE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.GET_PARTNER_BY_EMAIL_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.GET_PARTNER_BY_EMAIL_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.GET_PARTNER_BY_EMAIL_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_VALUES]: updateValuesReducer,
    [ActionTypes.LOGIN_OTHER_TEACHER_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOGIN_OTHER_TEACHER_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOGIN_OTHER_TEACHER_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };